/** The route of the public cover maker under `/app` (spec §2, design cover-editor g). */
export const COVER_MAKER_SEGMENT = 'cover-maker';
/** The page after a sign-in with a carried design: "Which song is this cover for?". */
export const COVER_CARRY_SEGMENT = 'continue';

/**
 * The path of the page that puts a carried design on a song; the router adds `/app`. With
 * `itemUuid` (`?item=<uuid>`), the page puts the design on that song at once: the "Add a song"
 * flow sends it back here from its cover step.
 */
export function coverCarryPath(itemUuid?: string): string {
  const base = `/${COVER_MAKER_SEGMENT}/${COVER_CARRY_SEGMENT}`;
  return itemUuid === undefined || itemUuid === '' ? base : `${base}?item=${encodeURIComponent(itemUuid)}`;
}

/** The `returnTo` value of a sign-in link that carries a design (relative to `/app`). */
export const COVER_CARRY_RETURN_TO = `${COVER_MAKER_SEGMENT}/${COVER_CARRY_SEGMENT}`;

/** True for `?embed=1`: the tool inside the frame of music24.com/song-artwork-maker (design g5). Pure. */
export function isCoverMakerEmbed(search: string): boolean {
  return new URLSearchParams(search).get('embed') === '1';
}

/**
 * True when the page is the public tool inside a frame of the website. The consent bar of the app
 * does not show there: the page around the frame owns it. Pure.
 */
export function isCoverMakerEmbedLocation(location: { pathname: string; search: string }): boolean {
  const path = location.pathname.replace(/\/+$/, '');
  return path.endsWith(`/${COVER_MAKER_SEGMENT}`) && isCoverMakerEmbed(location.search);
}

/** A lead token as the API makes it (43 URL-safe characters). */
const LEAD_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

/** The lead token of `?design=<token>` (the link of the "Your cover is saved" email), or null. Pure. */
export function leadTokenOf(value: string | null | undefined): string | null {
  return value !== null && value !== undefined && LEAD_TOKEN_PATTERN.test(value) ? value : null;
}
